import BrowserProtocol from 'farce/BrowserProtocol';

const browserProtocol = new BrowserProtocol();

export default browserProtocol;
